import { render, staticRenderFns } from "./GeneFunctionTable.vue?vue&type=template&id=1b8a621a&scoped=true"
import script from "./GeneFunctionTable.vue?vue&type=script&lang=js"
export * from "./GeneFunctionTable.vue?vue&type=script&lang=js"
import style0 from "./GeneFunctionTable.vue?vue&type=style&index=0&id=1b8a621a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a621a",
  null
  
)

export default component.exports